export const API_URL = process.env.VUE_APP_API;

export const REPORTING_URL = process.env.VUE_APP_REPORTING;

export const IS_DEV = !process.env.NODE_ENV.toLowerCase() === "production";

export const DateFormat = "dd-MM-yyyy";

export const DateTimeFormat = "dd-MM-yyyy HH:mm:ss";
